module.exports = KsysAppTemplateV2dot93dot0;